<template>
  <div>
    <v-data-table v-bind="this.$attrs" loading-text="Đang Tải" item-key="index" :options.sync="pagination"
      :items-per-page="5" :server-items-length="totalItems" :headers="headers" :items="busCheckins" :search="search"
      :loading="loading" no-data-text="Không có dữ liệu"
      :footer-props="{ 'items-per-page-text': 'Hiển thị mỗi trang', 'items-per-page-all-text': 'Tất cả', }">
      <template v-slot:[`footer.page-text`]="items">
        {{ items.pageStart }} - {{ items.pageStop }} trên tổng
        {{ items.itemsLength }}
      </template>

      <template v-slot:[`item.name`]="{ item }">
        <router-link :to="'/bus-checkin-detail/' + item.id" style="text-decoration: none">
          {{ item.bus && item.bus.name }}
        </router-link>
      </template>
      <template v-slot:[`item.driver`]="{ item }">
        {{ item.driver && item.driver.name }}
      </template>
      <template v-slot:[`item.phone`]="{ item }">
        {{ item.bus && item.bus.phone }}
      </template>
      <template v-slot:[`item.busTimeline`]="{ item }">
        <div>
          {{ item.bus_schedule | getBusTimeline }}
        </div>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <div v-if="$_get(item, 'status')">
          <v-chip small style="margin: 0" class="white--text" :color="item.status | busCheckinColor" label>
            {{ item.status | busCheckinStatus }}
          </v-chip>
        </div>
      </template>
      <template v-slot:[`item.countAbsent`]="{ item }">
        {{ item.metadata && item.metadata.countAbsent.length }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <router-link style="text-decoration: none" :to="`/bus-checkin-detail/${item.id}`">
          <v-icon color="primary">mdi-eye</v-icon>
        </router-link>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'

const originHeaders = [
  {
    text: 'Tên tuyến',
    value: 'name',
    align: 'left',
    width: '15%',
    sortable: false
  },
  {
    text: 'Tên lái xe',
    value: 'driver',
    width: '15%',
    align: 'left',
    sortable: false,
  },
  {
    text: 'Số điện thoại',
    value: 'phone',
    width: '15%',
    align: 'left',
    sortable: false,
  },
  {
    text: 'Chiều di chuyển',
    value: 'busTimeline',
    align: 'left',
    sortable: false,
    width: '20%'
  },
  {
    text: 'Trạng thái',
    value: 'status',
    align: 'center',
    sortable: false,
    width: '15%'
  },
  {
    text: 'Vắng',
    value: 'countAbsent',
    align: 'left',
    sortable: false,
    width: '10%'
  },
  {
    text: 'Thao tác',
    value: 'actions',
    align: 'center',
    sortable: false,
    width: '10%'
  }
]

export default {
  components: {},
  props: {},
  data() {
    return {
      selected: [],
      pagination: {},
      search: '',
      headers: originHeaders,
      title: '',
      status: null
    }
  },
  methods: {
    ...mapActions('BusCheckin', ['fetchBusTracking']),
    ...mapMutations({
      setItemPerPage: 'BusCheckin/setItemPerPage',
    })

  },
  computed: {
    ...mapState('BusCheckin', ['date', 'loading', 'totalItems']),
    ...mapGetters({
      busCheckins: 'BusCheckin/busCheckins'
    })
  },
  watch: {
    pagination: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.setItemPerPage(newOptions.itemsPerPage)
          this.$emit('paginationChange', { page: newOptions.page, itemsPerPage: newOptions.itemsPerPage })
        }
      },
      deep: true
    },
  }
}
</script>
<style lang="scss" scoped>
.border {
  border-bottom: 1px solid lightgray;
}
</style>
